// extracted by mini-css-extract-plugin
export default {"AssessmentComparePage":"AssessmentCompare_AssessmentComparePage__9g7d-"};